<div class="card border border-tertiary border-3 text-center p-3 h-100">
  <div class="card-body d-flex flex-column justify-content-center">
    <i
      *ngIf="showRemovalIcon"
      (click)="removeItem()"
      class="top-icon fs-25 bi bi-x-circle removal-icon"></i>
    <div class="top-icon bookmark">
      <app-item-shelves-bookmark
        [itemType]="'elearn_resource'"
        [itemOnAShelf]="resource.isOnUsersShelf"
        [itemId]="resource.id"></app-item-shelves-bookmark>
    </div>
    <i [ngClass]="[iconString, 'bi', 'fs-35px']"></i>
    <p class="h5 fs-16 fw-bold">{{ resource.title }}</p>
    <p class="card-text fs-11" [innerHTML]="description"></p>
  </div>
</div>
